import {AxiosInstance} from "axios";
import {FeatureRequestNoteEntity} from "@fenix/bug-report-entities/bug-report-entities";
import FeatureNoteRepositoryInterface from "@/services/Bug-report/Feature-request/Notes/interfaces";

export default class FeatureNoteRepository implements FeatureNoteRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  public async createNote(featureRequestId: number, body: string): Promise<FeatureRequestNoteEntity> {
    const url = `bug-report/features/${featureRequestId}/note`;
    const res = await this.axios.post(url, {body});
    return res.data;
  }

  public async getAll(featureRequestId:number, page?: number, take?: number, desc?: boolean): Promise<FeatureRequestNoteEntity[]> {
    const url = `bug-report/features/${featureRequestId}/note?page=${page}&take=${take}&desc=${desc}`;
    const res = await this.axios.get(url);
    return res.data;
  }
}
